import React from 'react'
import LandingFooter from '../components/LandingFooter'
import NavigationBar from '../components/NavigationBar'
import { MDBAccordion, MDBAccordionItem, MDBBreadcrumb, MDBBreadcrumbItem, MDBCard, MDBCardBody, MDBCardTitle, MDBCol, MDBContainer, MDBRow } from 'mdb-react-ui-kit'
import { Link } from 'react-router-dom'
import { Bell, Leadgeneration, PilatesStudio, SocialMedia, textnotification } from '../assets/images/images'
import { leadFaqs } from '../data/constants'
import ContactUs from '../components/ContactUs'
import RelatedProducts from '../components/RelatedProducts'

const LeadManagementLanding = () => {
    return (
        <>
            <NavigationBar />
            <div className="lp">
                <div className="lp_revenue section-white pt-5">
                    <MDBContainer>
                        <MDBBreadcrumb>
                            <MDBBreadcrumbItem>
                                <Link href='#'>Easymembr</Link>
                            </MDBBreadcrumbItem>
                            <MDBBreadcrumbItem>
                                <Link href='#'>Products</Link>
                            </MDBBreadcrumbItem>
                            <MDBBreadcrumbItem active>Lead Management</MDBBreadcrumbItem>
                        </MDBBreadcrumb>


                        <MDBRow className='align-items-center'>
                            <MDBCol sm={12} md={5} lg={5} xl={5}>
                                <h1 class="mm-main-heading text-dark">Lead Management:
                                    Increase Your Client Base</h1>
                                <p className="pt-3 text-description">
                                    A perfect solution that allows your studio to manage leads more effectively, engage potential customers, and seamlessly convert inquiries into active members.
                                </p>
                            </MDBCol>
                            <MDBCol sm={12} md={6} lg={6} xl={6}>.
                                <img src={PilatesStudio} alt="" width={650} />
                            </MDBCol>
                        </MDBRow>

                        <hr className='pb-5 mt-5' />
                        <div class="row align-items-center cta-v5">
                            <div class="col-md-1">
                                <img src={Bell} alt="Note" class="bell-icon" />
                            </div>
                            <div class="col-md-8">
                                <p>
                                    Take the first step towards transforming your studio's lead management by signing up for EasyMembr. Get Started today!
                                </p>
                            </div>
                            <div class="col-md-3">
                                <a href="#!" class="cta-button">
                                    Explore Now!</a>
                            </div>
                        </div>
                        <br />
                        <br />

                        <h2 style={{ fontSize: "24px" }} className='text-dark'>
                            EasyMembr : Lead Management Features
                        </h2>

                        <p>Improve your business workflow and boost your conversion rates through the innovative features of EasyMembr.</p>

                        <MDBRow>
                            <MDBCol sm={12} md={12} lg={12} className='mb-3' style={{ marginTop: '20px' }}>
                                <div className='card-v3'>
                                    <MDBCard className='shadow-0'>
                                        <MDBCardBody className='lp_header'>
                                            <img src={textnotification} alt="" className='card-icon' />
                                            <MDBCardTitle className='my-3 text-dark'>Automated Notifications and Alerts</MDBCardTitle>
                                            <div className='lp_small'>Stay on top of every inquiry with real-time notifications. Our software alerts your staff immediately when new leads come in, ensuring that every potential customer receives prompt attention.</div>
                                        </MDBCardBody>
                                    </MDBCard>
                                </div>
                            </MDBCol>
                            <MDBCol sm={12} md={7} lg={7} className='mb-3'>
                                <div className='card-v3'>
                                    <MDBCard className='shadow-0'>
                                        <MDBCardBody className='lp_header'>
                                            <img src={SocialMedia} alt="" className='card-icon' />
                                            <MDBCardTitle className='my-3 text-dark'>Direct Social Media Integration</MDBCardTitle>
                                            <div className='lp_small'>Effortlessly generate QR codes that link directly to your lead management system. Share these on social media to capture leads directly from social media platforms, connecting the gap between online engagement and real-world memberships.</div>
                                        </MDBCardBody>
                                    </MDBCard>
                                </div>
                            </MDBCol>
                            <MDBCol sm={12} md={5} lg={5} className='mb-3'>
                                <div className='card-v3'>
                                    <MDBCard className='shadow-0'>
                                        <MDBCardBody className='lp_header'>
                                            <img src={Leadgeneration} alt="" className='card-icon' />
                                            <MDBCardTitle className='my-3 text-dark'>Inquiry Handling</MDBCardTitle>
                                            <div className='lp_small'>Our software captures all client inquiries from social media, QR codes, or direct entries. Manage and respond to these inquiries efficiently to keep potential clients engaged and interested.</div>
                                        </MDBCardBody>
                                    </MDBCard>
                                </div>
                            </MDBCol>
                        </MDBRow>

                        <h2 style={{ fontSize: "24px" }} className='text-dark  mt-4'>
                            Streamlined Communication, Follow-Ups & Monitor Staff Performance
                        </h2>

                        <p>Improve your studio's engagement strategies with  EasyMembrs automated communication tools and monitor staff performance.</p>

                        <MDBRow>
                            <MDBCol sm={12} md={6} lg={6}>
                                <div class="note note-secondary mb-3">
                                    <div style={{ fontSize: "20px" }} className='text-dark fw-600 pb-2'>Automated Follow-Up System</div>
                                    <p>
                                        Our software automatically schedules and sends
                                        follow-up reminders, ensuring your team follows up
                                        with every lead at the right time.
                                    </p>

                                </div>
                            </MDBCol>
                            <MDBCol sm={12} md={6} lg={6}>
                                <div class="note note-secondary mb-3">
                                    <div style={{ fontSize: "20px" }} className='text-dark fw-600 pb-2'>Bulk Communication Tools
                                    </div>
                                    <p>
                                        Use our bulk SMS and WhatsApp features to send personalized messages to your leads, keeping them engaged with updates and offers, especially during festive seasons.
                                    </p>

                                </div>
                            </MDBCol>
                            <MDBCol sm={12} md={6} lg={6}>
                                <div class="note note-secondary mb-3">
                                    <div style={{ fontSize: "20px" }} className='text-dark fw-600 pb-2'>Customizable Lead Management</div>
                                    <p>
                                        Customize the software to your studio's specific needs. You can customize categories, follow-up types, sources, and statuses (e.g., hot, cold) and add optional custom fields to capture unique information about each lead.
                                    </p>
                                </div>
                            </MDBCol>
                            <MDBCol sm={12} md={6} lg={6}>
                                <div class="note note-secondary mb-3">
                                    <div style={{ fontSize: "20px" }} className='text-dark fw-600 pb-2'>Performance Analytics
                                    </div>
                                    <p>
                                        Track and measure each staff member's performance with detailed analytics on how many leads they convert. Use this data to recognize high performers and identify opportunities for training or improvement.
                                    </p>

                                </div>
                            </MDBCol>
                        </MDBRow>




                        <div class="row align-items-center cta-v5 mt-4">
                            <div class="col-md-1">
                                <img src={Bell} alt="Note" class="bell-icon" />
                            </div>
                            <div class="col-md-8">
                                <p>
                                    Request a Demo: See how EasyMembr can make a difference in your studio. Request a live demo and experience the benefits of our software.
                                </p>
                            </div>
                            <div class="col-md-3">
                                <a href="#!" class="cta-button">
                                    Request a Demo!</a>
                            </div>
                        </div>
                        <br />
                        <br />

                        <h2 style={{ fontSize: "24px" }} className='text-dark pt-4'>
                            Explore our FAQ section for details
                        </h2>
                        <p>
                            Software questions, answered
                        </p>



                        <MDBAccordion initialActive={1} borderless>
                            {leadFaqs.map((faq) => (
                                <MDBAccordionItem
                                    key={faq.id}
                                    collapseId={faq.id}
                                    headerTitle={faq.title}
                                >
                                    {faq.content.split('\n').map((line, index) => (
                                        <p key={index} style={{ marginBottom: '0.5rem' }}>{line}</p>
                                    ))}
                                </MDBAccordionItem>
                            ))}
                        </MDBAccordion>


                    </MDBContainer>
                </div>

                <div className="section-grey">
                    <ContactUs />
                </div>

                <div className="section-white">
                    <RelatedProducts />
                </div>
            </div>
            <LandingFooter />
        </>
    )
}

export default LeadManagementLanding
